﻿import { SET_LUTDATA, LutDataActionTypes } from './Types';
import { LutData } from '../../Utilities/LutApi';

const initialState: LutData | null = null;

export function lutDataReducer(state: LutData | null = initialState, action: LutDataActionTypes): LutData | null {
    switch (action.type) {
        case SET_LUTDATA: {
            return action.payload;
        }
        default:
            return state;
    }
}
